/* Halloween 2026 — Mystery Unboxed notify modals */
(function () {
  var openClass = 'hh2026-mystery-notify-open';

  function closeModal(modal) {
    if (!modal) return;
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    if (modal._mysteryHome && modal.parentNode !== modal._mysteryHome) {
      modal._mysteryHome.appendChild(modal);
    }
    if (!document.querySelector('.mystery-notify-modal:not([hidden])')) {
      document.documentElement.classList.remove(openClass);
    }
  }

  function closeAll() {
    document.querySelectorAll('.mystery-notify-modal:not([hidden])').forEach(closeModal);
  }

  function openModal(modal) {
    if (!modal) return;
    closeAll();
    if (!modal._mysteryHome) {
      modal._mysteryHome = modal.parentNode;
    }
    document.body.appendChild(modal);
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add(openClass);
    var closeBtn = modal.querySelector('.mystery-notify-close');
    if (closeBtn) closeBtn.focus();
  }

  function initRoot(root) {
    if (!root || root.dataset.hh2026MysteryInit === '1') return;
    root.dataset.hh2026MysteryInit = '1';

    root.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-mystery-notify-open]');
      if (!openBtn || !root.contains(openBtn)) return;
      e.preventDefault();
      openModal(document.getElementById(openBtn.getAttribute('data-mystery-notify-open')));
    });
  }

  document.addEventListener('click', function (e) {
    var closeEl = e.target.closest('[data-mystery-notify-close]');
    if (!closeEl) return;
    var modal = closeEl.closest('.mystery-notify-modal');
    if (!modal || modal.hidden) return;
    e.preventDefault();
    closeModal(modal);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeAll();
  });

  function boot() {
    document.querySelectorAll('[data-hh2026-mystery]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector('[data-hh2026-mystery]');
    if (root) {
      delete root.dataset.hh2026MysteryInit;
      initRoot(root);
    }
  });
})();
